import React from 'react';
import { Typography, Box } from '@mui/material';
import '../TiersCard/TiersCard.scss';
import CheckIcon from '@mui/icons-material/Check';
import CloseIcon from '@mui/icons-material/Close';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';

const TiersPicksCard = ({ tier, backgroundColor, textColor, interval, selectedPlayers = [], lastCard, currentRound }) => {
    // Find selected player for this tier
    const tierSelectedPlayers = selectedPlayers.filter(pick => 
        pick.interval === interval && pick.tier === tier.tier
    );

    // Function to get the total score for a player
    const getPlayerScore = (player) => {
        if (!player.tournamentData) return null;
        
        const td = player.tournamentData;
        
        if (td.IsWithdrawn) {
            return 'WD';
        } else if (currentRound > 1 && td.MadeCut === 0) {
            return 'Cut';
        } else if (td.TotalScore === undefined || td.TotalScore === null || td.TotalScore === 0) {
            return 'E';
        } else if (td.TotalScore > 0) {
            return `+${td.TotalScore}`;
        } else {
            return td.TotalScore;
        }
    };

    const hasSelection = tierSelectedPlayers?.length > 0;

    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('md'));
    
    const tierText = `Tier ${tier?.tier}`;
    const selectText = "Times Picked";
    const players = tier?.players || [];

    // Get the selected player's full info
    const selectedPlayerInfo = hasSelection 
        ? players.find(player => String(player.id) === String(tierSelectedPlayers[0]?.id))
        : null;
    
    const myPickText = hasSelection 
        ? tierSelectedPlayers[0].id.startsWith('no-pick') 
            ? "No Pick" 
            : players.find(player => String(player.id) === String(tierSelectedPlayers[0].id))?.name || "No Pick"
        : "No Pick";

    // Get the score for the selected player
    const myPickScore = selectedPlayerInfo ? getPlayerScore(selectedPlayerInfo) : null;

    const isPlayerSelected = (id) => {
        return tierSelectedPlayers.some(pick => String(pick.id) === String(id));
    };

    return (
        <Box 
            className="tiers-card-container"
            sx={{
                marginBottom: lastCard ? '60px' : '0',
            }}
        >
            <Box 
                className="tiers-card-top-border"
                sx={{ backgroundColor: backgroundColor }}
            >
                <Typography className="tiers-card-top-border-left-text" sx={{ color: textColor}}>{tierText}</Typography>
                <Typography className='tiers-card-top-border-right-text' sx={{ color: textColor}}>{selectText}</Typography>
            </Box>
          
            <Box className="tiers-card-list">
                {players.map((player) => (
                    <Box 
                        key={`${player.id}-${tier.tier}`}
                        sx={{
                            padding: '8px 16px',
                            fontSize: isMobile ? '12px' : '14px',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'space-between',
                            backgroundColor: isPlayerSelected(player.id) ? 'rgba(0, 170, 209, 0.1)' : 'transparent',
                            color: isPlayerSelected(player.id) ? '#00AAD1' : 'inherit',
                        }}
                    >
                        <Box sx={{ display: 'flex', alignItems: 'center', flex: '1' }}>
                            {isPlayerSelected(player.id) && <CheckIcon sx={{ marginRight: '8px', fontSize: '16px', color: '#00AAD1' }} />}
                            <span style={{ 
                                paddingLeft: isPlayerSelected(player.id) ? '0' : '24px',
                                fontWeight: isPlayerSelected(player.id) ? 800 : 700
                            }}>
                                {[
                                    player.logo && `${player.logo} `,
                                    player.rank && `(${player.rank})`,
                                    player.name,
                                ].filter(Boolean).join(" ")}
                                {getPlayerScore(player) && (
                                    <span style={{ 
                                        marginLeft: '8px',
                                        color: isPlayerSelected(player.id) ? '#00AAD1' : '#002129',
                                        fontWeight: 700
                                    }}>
                                        ({getPlayerScore(player)})
                                    </span>
                                )}
                            </span>
                        </Box>
                        <Box sx={{ 
                            textAlign: 'right', 
                            fontWeight: 700,
                            color: isPlayerSelected(player.id) ? '#00AAD1' : '#002129',
                        }}>
                            {player.pickCount ?? 0}
                        </Box>
                    </Box>
                ))}
            </Box>

            <Box className="tiers-card-bottom-border">
                <Typography className="tiers-card-bottom-border-text">
                    My Pick:&nbsp;
                    <span style={{ color: myPickText === "No Pick" ? "#CC293C" : "#002129" }}>
                        {myPickText}
                        {myPickText !== "No Pick" && myPickScore && (
                            <span style={{ 
                                marginLeft: '4px',
                                color: '#002129',
                                fontWeight: 700
                            }}>
                                ({myPickScore})
                            </span>
                        )}
                    </span>
                    {myPickText === "No Pick" && (
                        <CloseIcon sx={{ color: "#CC293C", marginTop: '-2px' }} />
                    )}
                </Typography>
            </Box>
        </Box>
    );
};

export default TiersPicksCard;